export const selectCurrentUser      = (state) => state.auth.user
export const selectAccessToken      = (state) => state.auth.accessToken
export const selectRefreshToken     = (state) => state.auth.refreshToken
export const selectIsAuthenticated  = (state) => !!state.auth.user
export const selectAuthLoading      = (state) => state.auth.isLoading
export const selectAuthError        = (state) => state.auth.error
export const selectIsAdmin          = (state) => state.auth.user?.role === 'admin'
